import React, { useState } from 'react'
import popImg2 from '../../images/new1.png'
import popImg from '../../images/pop-img.png'
import DelImg from '../../images/delete.png'
import './Model.css'
const Model = ({closeModel}) => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };
  return (
    <div className='model-main'>
      <div className="model">

        <div className="pop-head">
          <h5>Repair</h5>
         <img src={DelImg} onClick={()=> closeModel(false)} alt="" />
        </div>
        <div className="pop-body">
          <div className="pop-sidebar">
            <button  className={toggleState === 1 ? "active-butn" : ""}
                onClick={() => toggleTab(1)} >Repair 1</button>
            <button className={toggleState === 2 ? "active-butn" : ""}
                onClick={() => toggleTab(2)} >Repair 2</button>
          </div>
          <div className="pop-main">
            <div className={toggleState === 1 ? "pop-img active-img" : "pop-img"}
                onClick={() => toggleTab(1)}>
              <img src={popImg} alt="" />

            </div>
            <div className={toggleState === 2 ? "pop-img active-img" : "pop-img"}
                onClick={() => toggleTab(2)}>
              <img src={popImg2} alt="" />
              
            </div>
            <div className="pop-main-btn">
            <button>Date</button>
            <button>User</button>
            <button>States</button>
            </div>
          </div>
        </div>

      </div>
    </div>

  )
}

export default Model;